import { Box, Grid, Stack, Tab, Tabs, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { getUserService } from "../services/loginService";
import { setUserData } from "../features/authSlice";
import { getCounties, getDefinitions } from "../services/settingsService";
import { setCounties, setDefinitions } from "../features/settingsSlice";
import Users from "./users";
import CountiesSettings from "./countiesSettings";
import CustomFieldsSettings from "./customFieldsSettings";

const Settings = () => {
  const [tab, setTab] = useState(0);
  const admin = useSelector((state) => state.auth.value.admin);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    async function getData() {
      const res = await getUserService();
      if (!res.name) {
        navigate("/app/newUser");
      }
      dispatch(setUserData(res));

      const [defs, counties] = await Promise.all([getDefinitions(), getCounties()]);
      if (defs) {
        dispatch(setDefinitions(defs));
      }
      if (counties) {
        dispatch(setCounties(counties));
      }
    }
    getData();
  }, [dispatch, navigate]);

  return (
    <Box sx={{ p: { xs: 2, md: 3 } }}>
      <Stack spacing={0.5} mb={2}>
        <Typography variant="h4">Settings</Typography>
        <Typography variant="body2" color="text.secondary">
          Manage users, counties, and the custom fields that shape your CRM.
        </Typography>
      </Stack>

      <Tabs value={tab} onChange={(e, next) => setTab(next)} sx={{ mb: 2 }}>
        <Tab label="Users" />
        {admin ? <Tab label="Counties" /> : null}
        {admin ? <Tab label="Custom Fields" /> : null}
      </Tabs>

      {tab === 0 ? (
        <Grid container>
          <Users />
        </Grid>
      ) : null}
      {tab === 1 && admin ? <CountiesSettings /> : null}
      {tab === 2 && admin ? <CustomFieldsSettings /> : null}
    </Box>
  );
};

export default Settings;
